module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAABP0lEQVQ4T4XTsW+OURzF8c9RQiKRiJG/wN6QSDS2isSAwSB0sGnaFXuFURgN0hgEA5PYSJow+BPUTmwsSPzkvrltXvU8b+/4PPeb87vnnF+gqo7gMtaTfG/fxk46cBtreIvFJD93A47hA47ieVNL8mcImih0lePYwGE8SLIyE+jQAt5gP24mubcT2laYUrqAZ9iDpSTr09B/QFdabmPhF84naaqTMwh0qLnW3PuBM0k+zgQ69BjX8AWnkmyOKnRgH17hLD7j5EygQyfwvo+/vJvCabzs2bybGDBWgaq6iCc4gBe40iozZusN3MccHmJ1qypDwd3BrVbiZmuSu4PBVdVePOo2/sb1nSlv51BVB/uciz2oS9Pp/qPQl+c15vEV57ZSHWxrVbUHtod96suzOb5vpKoO4SqeJvk263L79xdGeW+a3OzCVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/DiscountAgentInvite/H5/jiantou.png
// module id = M5Oe
// module chunks = 69